import request from '@/utils/http';
import { SRM_FILE_PRE,PFX } from '../constant/constant.js';

// 招标结果-列表信息 入参：{"bidNo":"ZB202207080001"}
export const getTableList = (params) => {
    return request({
        url: '/api-srm-web/bid/quoteTemplate/bidQuoteResultParentList',
        method: 'post',
        data: params
    });
};
// 招标结果-列表信息-字节点列表 入参：{"bidNo":"ZB202207080001","quoteCode": "2000000"}
export const getTableListChildList = (params) => {
    return request({
        url: '/api-srm-web/bid/quoteTemplate/bidQuoteResultChildList',
        method: 'post',
        data: params
    });
};
// 招标结果-推送价格表盖章
export const pushResultStamp = (params) => {
    return request({
        url: `/api-srm-web/bid/bidResultStampPush`,
        method: 'post',
        data: params
    });
};
// 招标结果-招标结果审批
export const approveBidConsequence = (bidNo, params) => {
    return request({
        url: `/api-srm-web/bid/bidConsequenceApprove/${bidNo}`,
        method: 'post',
        data: params
    });
};
// 合同重推
export const refreshPush = (params) => {
    return request({
        url: `/api-srm-web/bid/bidHead/getBidHeadResult`,
        method: 'post',
        data: params
    });
};
// 流标
export const bidders = (params) => {
    return request({
        url: `/api-srm-web/bid/bidHead/gameOver`,
        method: 'post',
        data: params
    });
};
// 导出
export const bidQuoteExport = (bidNo) => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidQuoteTemplate/bidQuoteExportListExport/${bidNo}`,
        method: 'get',
        responseType: 'arraybuffer'
    });
};
// 导入降本信息下载模板接口
export const costReductionDownloadTpl = (params) => {
    return request({
        url: `${SRM_FILE_PRE}/bid/quoteTemplate/costReductionDownloadTpl`,
        method: 'get',
        params
    });
};

// 招标结果上传附件列表查询接口
export const uplaodQueryByBidNo = (params) => {
    return request({
        url: `${PFX}/bid/bidResultAttachment/queryByBidNo/${params.bidNo}`,
        method: 'get',
        params
    });
};

// 招标结果上传附件保存接口
export const bidResultAttachmentSave = (data) => {
    return request({
        url: `${PFX}/bid/bidResultAttachment/save`,
        method: 'post',
        data
    });
};

// 查询招标结果的流程状态
export const queryAuditStatus = (params) => {
    return request({
        url: `${PFX}/bid/bidResultAttachment/queryAuditStatus/${params.bidNo}`,
        method: 'get',
        params
    });
};

// 招标结果上传附件下载模板接口
export const bidResultTemplateDownloadTpl = (params) => {
    return request({
        url: `${SRM_FILE_PRE}/bid/bidResultTemplate/download/${params.fileAttribute}`,
        method: 'get',
        params
    });
};